<template>
    <InputSelect label="Город">
        <Multiselect
            v-model="value"
            searchable
            :delay="300"
            :resolve-on-load="true"
            :min-chars="2"
            :options="getCities"
            placeholder="Город"/>
    </InputSelect>
</template>

<script>
import InputSelect from "@/components/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect";

export default {
    name: "CitySelect",
    components: {InputSelect, Multiselect},
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    methods: {
        async getCities(query = '') {
            let formData = new FormData();
            formData.append('q', query);

            let arResult = await this.$axios.post('/api/cart/cities/', formData)
                .then(response => {
                    return response.data.data.map(item => {
                        return {
                            value: item.cityCode,
                            label: item.cityName,
                        }
                    })
                })
                .catch(() => {
                    return []
                });
            return arResult;
        }
    }
}
</script>

<style scoped>

</style>